const showBackStub = type => {

    if (type === 'mobile'){
        window.__backStubMobile__.style.display = 'block';
        window.__backStubResolution__.style.display = 'none';
    }

    if (type === 'resolution') {
        window.__backStubMobile__.style.display = 'none';
        window.__backStubResolution__.style.display = 'block';
    }

    if (type === false){
        window.__backStubMobile__.style.display = 'none';
        window.__backStubResolution__.style.display = 'none';
    }
};

export default showBackStub;


// WEBPACK FOOTER //
// ./src/js/utils/showBackStub.js